import { TLocale } from "@src/i18n";
import { API_LANGUAGE_MAP } from "@src/utils/languageHelper";
import { vhmproperty } from "@src/proto/jsonapi";
import { jsonFetch } from "@src/utils/fetch";

export function fetchProperty(propertyId: string, local: TLocale) {
  return jsonFetch<vhmproperty.DetailProperty>(
    `/api/property_${propertyId}_${API_LANGUAGE_MAP[local]}.json`
  );
}
